import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type SectionMessagesStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages'

export const SectionMessagesContext = createContext<SectionMessagesStore | null>(null)

export const useSectionMessagesContext = () => {
  const context = useContext(SectionMessagesContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SectionMessagesContext')

  return context
}

type IProviderSectionMessagesProps = {
  value: SectionMessagesStore
  children: ReactNode
}

export const ProviderSectionMessages: FC<IProviderSectionMessagesProps> = ({ value, children }) => {
  return <SectionMessagesContext.Provider value={value}>{children}</SectionMessagesContext.Provider>
}
